const placementFaqData = [
  {
    id: "faq-01",
    Question: "What is the season for placements and internships at Medhavi Skills University?",
    Answer: "Our placement season is all-year round, except the time when the university examinations are being conducted."
  },
  {
    id: "faq-02",
    Question: "Who do I contact to recruit students from Medhavi Skills University?",
    Answer: "You can drop us a mail at placement@msu.edu.in. Alternatively, you can contact one of our Placement Officers directly at 9031200225 / 9031200226."
  },
  {
    id: "faq-03",
    Question: "Will I have a particular point of contact in College for the recruitment procedure?",
    Answer: "Yes. Every company/organisation is assigned a particular representative (POC) from the Placement Cell who will help facilitate the recruitment process. He or she will be the link between the company/organisation and the University. The representative can be reached on both email and telephone and will assist the recruiters at every stage of the recruitment process."
  },
  {
    id: "faq-04",
    Question: "What facilities are available to an on-campus recruiter?",
    Answer: "Companies/Organisations have the freedom to conduct their recruitment process both on and off-campus. Our classrooms and Seminar Halls are large, spacious and Wi-Fi enabled and can be put to the companies’/organisations' disposal when they come on campus for placements. Projectors for presentations and audio systems for talks being conducted are available in every classroom."
  },
  {
    id: "faq-05",
    Question: "Can the recruiters conduct a recruitment process online?",
    Answer: "The CCDP places no restrictions on the format for the recruitment process(es). The companies/organisations can carry out their recruitment process(es) in whichever manner they see fit; the CCDP will ensure that it is carried out smoothly and efficiently. The mode of the interview and the number of rounds can also be suggested to the CCDP. CCDP will try to make all the arrangements for a smooth process."
  },
  {
    id: "faq-06",
    Question: "Are there any charges for companies to participate in the placement process?",
    Answer: "No, there are no fees or surcharges for companies to participate in the placement process. We aim to facilitate a seamless and mutually beneficial hiring experience for all recruiting organisations."
  },
  {
    id: "faq-07",
    Question: "As a student, how can I reach the Placement Cell?",
    Answer: "You can drop us an email at placement@msu.edu.in. You may also visit the Placement Cell at Campus K1 Building – 1st Floor. Alternatively, you can connect with the respective HOS or Placement Coordinator of your school."
  },
  {
    id: "faq-08",
    Question: "What are the avenues for organisations to engage and collaborate beyond campus placements?",
    Answer: "Beyond recruitment, organisations can engage with the university through various initiatives such as guest lectures, seminars, workshops, and long-term collaborations. For further discussion and coordination, you may connect with Megha Sood – Manager, Strategic Partnership and Alliances, Founder’s Office."
  },
  {
    id: "faq-09",
    Question: "How can I explore the Placement Cell’s brochure and key details?",
    Answer: <>To know more about our Placement Cell, you can refer to the provided link. The placement brochure is available, which includes detailed information about our programs.  <br></br><a className="blue" href="https://cdn.msu.edu.in/msu-reavamp/pdf/Placement+%26+OJL+brochure.pdf" target="_blank">Placement Brochure</a></>
  }
];

export default placementFaqData;